"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EEmailType;
(function (EEmailType) {
    EEmailType["USER"] = "USER";
    EEmailType["MANAGER"] = "MANAGER";
})(EEmailType = exports.EEmailType || (exports.EEmailType = {}));
var EEmailLineItem;
(function (EEmailLineItem) {
    EEmailLineItem["MAIL_STATEMENTS"] = "MAIL_STATEMENTS";
    EEmailLineItem["RETURNED_STATEMENTS"] = "RETURNED_STATEMENTS";
    EEmailLineItem["AUTO_PAY_SCHEDULED_PAYMENTS"] = "AUTO_PAY_SCHEDULED_PAYMENTS";
    EEmailLineItem["DECLINED_PAYMENTS"] = "DECLINED_PAYMENTS";
    EEmailLineItem["SYNC_TO_PCC"] = "SYNC_TO_PCC";
    EEmailLineItem["POSTED_IN_PCC"] = "POSTED_IN_PCC";
    EEmailLineItem["MARKED_IN_NCS"] = "MARKED_IN_NCS";
    EEmailLineItem["HMO_SYNC"] = "HMO_SYNC";
    EEmailLineItem["MAIL_COLLECTIONS"] = "MAIL_COLLECTIONS";
    EEmailLineItem["RETURNED_COLLECTIONS"] = "RETURNED_COLLECTIONS";
    EEmailLineItem["CALLS_COLLECTIONS"] = "CALLS_COLLECTIONS";
})(EEmailLineItem = exports.EEmailLineItem || (exports.EEmailLineItem = {}));
